export const FIELD_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  SELECT: 'select',
  MULTI_SELECT: 'multi_select',
  AUTOCOMPLETE: 'autocomplete',
  AUTocomplete: 'autocomplete',
  URL: 'url',
  PASSWORD: 'password',
};

export const toBool = (value, fallback = true) => {
  if (value === undefined || value === null) return fallback;
  return value === 1 || value === true;
};

export const normalizeInstitutions = (value) => (Array.isArray(value) ? value : []);

export const DICOM_CONNECTION_FIELDS = [
  { key: 'name', labelKey: 'Settings.name', type: FIELD_TYPES.TEXT, required: true },
  { key: 'ip', labelKey: 'Settings.ip', type: FIELD_TYPES.TEXT, required: true },
  { key: 'aet', labelKey: 'Settings.aet', type: FIELD_TYPES.TEXT, required: true },
  { key: 'port', labelKey: 'Settings.port', type: FIELD_TYPES.NUMBER, required: true },
];

export const INSTITUTIONS_FIELD = {
  key: 'institutions',
  labelKey: 'Settings.institutions_served',
  type: FIELD_TYPES.AUTOCOMPLETE,
  required: false,
  multiple: true,
  freeSolo: true,
  display: 'institutions',
};

export const SEND_MODE_FIELDS = [
  { key: 'send_automatic', labelKey: 'Settings.direct', type: FIELD_TYPES.BOOLEAN, required: false },
  { key: 'send_manual', labelKey: 'Settings.manual', type: FIELD_TYPES.BOOLEAN, required: false },
];

export const isFieldVisible = (field, form) => {
  if (!field?.showWhen) return true;

  const { key, value, values } = field.showWhen;
  const current = form?.[key];

  if (values) return values.includes(current);
  return current === value;
};

export const serializeFieldValue = (field, value) => {
  if (field.key === 'institutions') return value || [];

  if (field.type === FIELD_TYPES.NUMBER) {
    return Number(value);
  }

  if (field.type === FIELD_TYPES.BOOLEAN) {
    return value ? 1 : 0;
  }

  if (field.type === FIELD_TYPES.SELECT) {
    const firstOptionValue = field.options?.[0]?.value;
    return typeof firstOptionValue === 'number' ? Number(value) : value;
  }

  return typeof value === 'string' ? value.trim() : value;
};
